class RelatedWork extends HTMLElement {
  static observedAttributes = ["product-id"];

  connectedCallback() {
    this.container = this.querySelector(".related-work__scroll");
    this.scrollLeftBtn = this.querySelector(".related-work__arrow--left");
    this.scrollRightBtn = this.querySelector(".related-work__arrow--right");
    this.scrollAmount = 300;

    if (!this.container) return;

    this.toggleArrows();
    this.scrollLeftBtn?.addEventListener("click", () =>
      this.container.scrollBy({ left: -this.scrollAmount, behavior: "smooth" }),
    );
    this.scrollRightBtn?.addEventListener("click", () =>
      this.container.scrollBy({ left: this.scrollAmount, behavior: "smooth" }),
    );
    this.container.addEventListener("scroll", this.toggleArrows.bind(this));
    window.addEventListener("resize", this.toggleArrows.bind(this));
  }

  toggleArrows() {
    if (!this.scrollLeftBtn || !this.scrollRightBtn) return;
    const atStart = this.container.scrollLeft <= 0;
    const atEnd =
      Math.ceil(this.container.scrollLeft + this.container.offsetWidth) >=
      this.container.scrollWidth;
    this.scrollLeftBtn.style.display = atStart ? "none" : "block";
    this.scrollRightBtn.style.display = atEnd ? "none" : "block";
  }

  attributeChangedCallback(name) {
    if (name === "product-id") this._load();
  }

  _load() {
    const url = this.getAttribute("url");
    const productId = this.getAttribute("product-id");
    const sectionId = this.getAttribute("section-id");
    const intent = this.getAttribute("intent") || "related";

    fetch(
      `${url}?product_id=${productId}&section_id=${sectionId}&intent=${intent}`,
    )
      .then((res) => res.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const recommendations = doc.querySelector("[data-recommendations]");
        if (!recommendations) return this.removeIfEmpty.remove();

        [...this.children].forEach((c) => c.remove());
        this.append(
          document
            .createRange()
            .createContextualFragment(recommendations.outerHTML),
        );
        this.container = this.querySelector(".related-work__scroll");
        this.toggleArrows();
      });
  }

  get removeIfEmpty() {
    const selector = this.getAttribute("remove-if-empty");
    return selector ? this.closest(selector) : this;
  }
}

if (!customElements.get("related-work"))
  customElements.define("related-work", RelatedWork);
